var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _path17, _g2, _path18, _path19, _path20, _path21, _path22, _path23, _g3, _path24, _path25, _path26, _path27, _path28, _path29, _g4, _path30, _path31, _path32, _path33, _path34, _path35, _g5, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g6, _path50, _path51, _path52, _g7, _path53, _path54, _path55, _path56, _path57, _path58, _g8, _path59, _path60, _path61, _path62, _path63, _path64, _g9, _path65, _path66, _path67, _path68, _path69, _path70, _g10, _path71, _g11, _path72, _g12, _path73, _g13, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCharts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 160,
    viewBox: "0 0 211 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.319 100.234C199.194 95.6253 199.552 87.7665 195.512 84.5307C191.962 81.6898 189.202 85.5454 188.206 88.6557C185.793 96.2009 186.926 104.521 186.933 112.31C186.933 112.428 186.933 112.546 186.933 112.679C186.745 118.412 186.055 124.614 186.682 130.337C186.682 130.337 186.066 124.603 181.565 127.061C177.064 129.518 183.816 142.413 183.816 142.413C183.816 142.413 178.495 138.524 176.038 141.8C173.581 145.077 179.108 148.759 179.108 148.759C179.108 148.759 173.99 147.327 173.99 148.759C173.99 150.191 175.628 151.419 180.336 152.035H205.713C205.713 152.035 209.809 149.781 208.99 147.327C208.171 144.874 203.868 146.287 203.868 146.287C203.868 146.287 210.421 138.303 210.012 134.823C209.602 131.344 201.208 135.44 201.208 135.44C201.208 135.44 207.757 118.859 206.529 111.491C205.562 105.687 201.057 109.646 198.603 111.889C199.181 108.032 199.42 104.132 199.319 100.234Z",
    fill: "#2F80ED",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M199.319 100.234C199.194 95.6253 199.552 87.7665 195.512 84.5307C191.962 81.6898 189.202 85.5454 188.206 88.6557C185.793 96.2009 186.926 104.521 186.933 112.31C186.933 112.428 186.933 112.546 186.933 112.679C186.745 118.412 186.055 124.614 186.682 130.337C186.682 130.337 186.066 124.603 181.565 127.061C177.064 129.518 183.816 142.413 183.816 142.413C183.816 142.413 178.495 138.524 176.038 141.8C173.581 145.077 179.108 148.759 179.108 148.759C179.108 148.759 173.99 147.327 173.99 148.759C173.99 150.191 175.628 151.419 180.336 152.035H205.713C205.713 152.035 209.809 149.781 208.99 147.327C208.171 144.874 203.868 146.287 203.868 146.287C203.868 146.287 210.421 138.303 210.012 134.823C209.602 131.344 201.208 135.44 201.208 135.44C201.208 135.44 207.757 118.859 206.529 111.491C205.562 105.687 201.057 109.646 198.603 111.889C199.181 108.032 199.42 104.132 199.319 100.234Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M191.176 151.814L193.021 95.5225",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192.201 128.275L201.82 119.269",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M196.703 124.179L198.751 118.449",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184.218 135.233L191.586 143.218",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M203.868 139.738L191.585 146.084",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M197.319 143.42L201.821 143.217",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M191.176 151.814L193.021 95.5225",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M192.201 128.275L201.82 119.269",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M196.703 124.179L198.751 118.449",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M184.218 135.233L191.586 143.218",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M203.868 139.738L191.585 146.084",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M197.319 143.42L201.821 143.217",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.175 151.814L193.02 95.5225",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.201 128.275L201.82 119.269",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.702 124.179L198.75 118.449",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.217 135.233L191.585 143.218",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.868 139.738L191.585 146.084",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.318 143.421L201.82 143.218",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M156.014 140.439C156.014 146.162 160.549 150.803 160.549 150.803C160.549 150.803 165.083 146.162 165.083 140.439C165.083 134.717 160.549 130.075 160.549 130.075C160.549 130.075 156.014 134.713 156.014 140.439Z",
    fill: "#2F80ED"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M152.871 149.268C155.084 151.751 158.826 152.021 158.826 152.021C158.826 152.021 159.006 148.261 156.807 145.778C154.608 143.295 150.852 143.025 150.852 143.025C150.852 143.025 150.668 146.785 152.871 149.268Z",
    fill: "#2F80ED"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M164.426 145.693C162.113 148.073 162.127 151.836 162.127 151.836C162.127 151.836 165.887 151.737 168.197 149.353C170.506 146.97 170.499 143.21 170.499 143.21C170.499 143.21 166.736 143.31 164.426 145.693Z",
    fill: "#2F80ED"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.011 140.439C156.011 146.162 160.546 150.803 160.546 150.803C160.546 150.803 165.08 146.162 165.08 140.439C165.08 134.717 160.546 130.075 160.546 130.075C160.546 130.075 156.011 134.713 156.011 140.439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.546 150.803V130.075",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.546 137.443L158.007 135.226",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.586 140.867L163.73 136.314",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.546 142.841L156.797 139.498",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.586 145.501L164.294 142.199",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.586 147.8L157.683 145.501",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.868 149.268C155.081 151.751 158.823 152.021 158.823 152.021C158.823 152.021 159.003 148.261 156.804 145.778C154.606 143.295 150.85 143.025 150.85 143.025C150.85 143.025 150.665 146.785 152.868 149.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.823 152.021L150.85 143.025",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.683 146.225L151.728 146.239",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.019 147.693L154.631 144.509",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.76 148.568L152.849 148.557",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.801 149.704L157.137 146.845",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.686 150.7L155.542 150.822",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.424 145.693C162.11 148.073 162.125 151.836 162.125 151.836C162.125 151.836 165.885 151.737 168.194 149.353C170.504 146.97 170.497 143.21 170.497 143.21C170.497 143.21 166.733 143.31 164.424 145.693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.125 151.836L170.497 143.21",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.519 146.276L167.36 144.328",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.154 147.719L169.301 147.092",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.338 148.523L165.132 145.619",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.279 149.645L167.157 149.77",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.353 150.601L163.073 148.476",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M160.549 150.803V130.075",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M160.549 137.443L158.01 135.226",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M160.589 140.867L163.732 136.314",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M160.548 142.841L156.8 139.498",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M160.589 145.501L164.297 142.199",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M160.589 147.8L157.686 145.501",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.552 150.803V130.075",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.552 137.443L158.014 135.226",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.592 140.867L163.736 136.314",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.552 142.841L156.803 139.498",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.592 145.501L164.3 142.199",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.592 147.8L157.688 145.501",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M158.826 152.021L150.853 143.025",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M153.686 146.225L151.73 146.239",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M155.022 147.693L154.634 144.509",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M155.763 148.567L152.852 148.556",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M156.804 149.703L157.139 146.844",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M157.69 150.7L155.546 150.822",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.827 152.02L150.854 143.024",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.687 146.224L151.731 146.238",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.023 147.692L154.635 144.508",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.764 148.566L152.853 148.555",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.805 149.702L157.141 146.843",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.691 150.699L155.547 150.821",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M162.127 151.836L170.499 143.21",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M167.522 146.276L167.363 144.328",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M166.157 147.719L169.304 147.092",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M165.341 148.523L165.135 145.619",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M164.283 149.645L167.161 149.77",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M163.356 150.6L163.076 148.475",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.13 151.836L170.502 143.21",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.524 146.276L167.366 144.328",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.16 147.719L169.307 147.092",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.344 148.523L165.138 145.619",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.285 149.645L167.163 149.77",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.359 150.6L163.079 148.475",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7109 100.234C11.8326 95.6253 11.4784 87.7665 15.5185 84.5307C19.0679 81.6898 21.8277 85.5454 22.8202 88.6557C25.2369 96.2009 24.1005 104.521 24.0968 112.31C24.0968 112.428 24.0968 112.546 24.0968 112.679C24.2886 118.412 24.9749 124.614 24.3514 130.337C24.3514 130.337 24.9638 124.603 29.4688 127.061C33.9738 129.518 27.2145 142.413 27.2145 142.413C27.2145 142.413 32.5386 138.524 34.9958 141.8C37.4531 145.077 31.9335 148.744 31.9335 148.744C31.9335 148.744 37.0509 147.313 37.0509 148.744C37.0509 150.176 35.4127 151.404 30.7048 152.021H5.3168C5.3168 152.021 1.22137 149.766 2.04045 147.313C2.85954 144.859 7.15791 146.287 7.15791 146.287C7.15791 146.287 0.608894 138.303 1.01844 134.823C1.42798 131.344 9.82179 135.44 9.82179 135.44C9.82179 135.44 3.26908 118.859 4.49772 111.502C5.46439 105.698 9.97306 109.657 12.4229 111.9C11.846 108.039 11.6077 104.136 11.7109 100.234Z",
    fill: "#2F80ED",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.7109 100.234C11.8326 95.6253 11.4784 87.7665 15.5185 84.5307C19.0679 81.6898 21.8277 85.5454 22.8202 88.6557C25.2369 96.2009 24.1005 104.521 24.0968 112.31C24.0968 112.428 24.0968 112.546 24.0968 112.679C24.2886 118.412 24.9749 124.614 24.3514 130.337C24.3514 130.337 24.9638 124.603 29.4688 127.061C33.9738 129.518 27.2145 142.413 27.2145 142.413C27.2145 142.413 32.5386 138.524 34.9958 141.8C37.4531 145.077 31.9335 148.744 31.9335 148.744C31.9335 148.744 37.0509 147.313 37.0509 148.744C37.0509 150.176 35.4127 151.404 30.7048 152.021H5.3168C5.3168 152.021 1.22137 149.766 2.04045 147.313C2.85954 144.859 7.15791 146.287 7.15791 146.287C7.15791 146.287 0.608894 138.303 1.01844 134.823C1.42798 131.344 9.82179 135.44 9.82179 135.44C9.82179 135.44 3.26908 118.859 4.49772 111.502C5.46439 105.698 9.97306 109.657 12.4229 111.9C11.846 108.039 11.6077 104.136 11.7109 100.234Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8499 151.814L18.0088 95.5225",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8285 128.275L9.20605 119.269",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3231 124.179L12.2754 118.449",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M26.809 135.233L19.4409 143.218",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1582 139.738L19.4408 146.084",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M13.711 143.42L9.20605 143.217",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8499 151.814L18.0088 95.5225",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8285 128.275L9.20605 119.269",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3231 124.179L12.2754 118.449",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M26.809 135.233L19.4409 143.218",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1582 139.738L19.4408 146.084",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M13.711 143.42L9.20605 143.217",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8514 151.814L18.0103 95.5225",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.83 128.275L9.20752 119.269",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3251 124.179L12.2773 118.449",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8105 135.233L19.4424 143.218",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15967 139.738L19.4423 146.084",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7125 143.421L9.20752 143.218",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7535 140.439C55.7535 146.162 51.219 150.803 51.219 150.803C51.219 150.803 46.6919 146.162 46.6919 140.439C46.6919 134.717 51.2264 130.075 51.2264 130.075C51.2264 130.075 55.7535 134.713 55.7535 140.439Z",
    fill: "#2F80ED"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8936 149.268C56.6799 151.751 52.9387 152.021 52.9387 152.021C52.9387 152.021 52.7579 148.261 54.9605 145.778C57.1632 143.295 60.9155 143.025 60.9155 143.025C60.9155 143.025 61.0816 146.785 58.8936 149.268Z",
    fill: "#2F80ED"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3411 145.693C49.6508 148.073 49.6397 151.836 49.6397 151.836C49.6397 151.836 45.88 151.737 43.5667 149.353C41.2533 146.97 41.2681 143.21 41.2681 143.21C41.2681 143.21 45.0278 143.31 47.3411 145.693Z",
    fill: "#2F80ED"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.756 140.439C55.756 146.162 51.2215 150.803 51.2215 150.803C51.2215 150.803 46.6943 146.162 46.6943 140.439C46.6943 134.717 51.2288 130.075 51.2288 130.075C51.2288 130.075 55.756 134.713 55.756 140.439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2217 150.803V130.075",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2217 137.443L53.7601 135.226",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1806 140.867L48.0371 136.314",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2217 142.841L54.9703 139.498",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1802 145.501L47.4722 142.199",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1807 147.8L54.0807 145.501",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8961 149.268C56.6823 151.751 52.9411 152.021 52.9411 152.021C52.9411 152.021 52.7603 148.261 54.963 145.778C57.1657 143.295 60.918 143.025 60.918 143.025C60.918 143.025 61.084 146.785 58.8961 149.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9404 152.021L60.9173 143.025",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.084 146.225L60.0358 146.239",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.748 147.693L57.1355 144.509",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0034 148.568L58.9182 148.557",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9627 149.704L54.627 146.845",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0811 150.7L56.2247 150.822",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3436 145.693C49.6532 148.073 49.6422 151.836 49.6422 151.836C49.6422 151.836 45.8825 151.737 43.5691 149.353C41.2558 146.97 41.2705 143.21 41.2705 143.21C41.2705 143.21 45.0302 143.31 47.3436 145.693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6422 151.836L41.2705 143.21",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2441 146.276L44.4065 144.328",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.613 147.719L42.4658 147.092",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4248 148.523L46.6351 145.619",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4838 149.645L44.606 149.77",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4131 150.601L48.6898 148.476",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2192 150.803V130.075",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2192 137.443L53.7577 135.226",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1782 140.867L48.0347 136.314",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2192 142.841L54.9679 139.498",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1787 145.501L47.4707 142.199",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1787 147.8L54.0787 145.501",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.2207 150.803V130.075",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2207 137.443L53.7591 135.226",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1801 140.867L48.0366 136.314",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2207 142.841L54.9693 139.498",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1802 145.501L47.4722 142.199",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1802 147.8L54.0802 145.501",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M52.938 152.021L60.9149 143.025",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0815 146.225L60.0333 146.239",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7461 147.693L57.1335 144.509",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M56.001 148.567L58.9158 148.556",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9603 149.703L54.6245 146.844",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0786 150.7L56.2223 150.822",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.939 152.02L60.9159 143.024",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.082 146.224L60.0338 146.238",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7466 147.692L57.134 144.508",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0015 148.566L58.9162 148.555",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9612 149.702L54.6255 146.843",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0791 150.699L56.2227 150.821",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6397 151.836L41.2681 143.21",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2417 146.276L44.404 144.328",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6106 147.719L42.4634 147.092",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4224 148.523L46.6327 145.619",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4814 149.645L44.6035 149.77",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4116 150.6L48.6883 148.475",
    stroke: "#2F80ED",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6422 151.836L41.2705 143.21",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2441 146.276L44.4065 144.328",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.613 147.719L42.4658 147.092",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4248 148.523L46.6351 145.619",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4838 149.645L44.606 149.77",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4131 150.6L48.6898 148.475",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M157.889 42.3659H58.1487C58.1188 42.3664 58.0892 42.361 58.0614 42.3499C58.0337 42.3388 58.0084 42.3223 57.9871 42.3013C57.9659 42.2804 57.9489 42.2554 57.9374 42.2279C57.9259 42.2003 57.9199 42.1707 57.9199 42.1409C57.9199 42.0802 57.944 42.022 57.9869 41.9791C58.0298 41.9362 58.088 41.9121 58.1487 41.9121H157.889C157.919 41.9121 157.949 41.918 157.976 41.9296C158.004 41.9411 158.029 41.958 158.05 41.9793C158.071 42.0006 158.087 42.0259 158.098 42.0536C158.109 42.0813 158.115 42.111 158.114 42.1409C158.114 42.2006 158.091 42.2578 158.048 42.3C158.006 42.3422 157.949 42.3659 157.889 42.3659Z",
    fill: "#2F80ED"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.887 42.3659H58.1462C58.1164 42.3664 58.0867 42.361 58.059 42.3499C58.0312 42.3388 58.006 42.3223 57.9847 42.3013C57.9634 42.2804 57.9465 42.2554 57.935 42.2279C57.9234 42.2003 57.9175 42.1707 57.9175 42.1409C57.9175 42.0802 57.9416 42.022 57.9845 41.9791C58.0274 41.9362 58.0856 41.9121 58.1462 41.9121H157.887C157.917 41.9121 157.946 41.918 157.974 41.9296C158.001 41.9411 158.026 41.958 158.047 41.9793C158.068 42.0006 158.085 42.0259 158.096 42.0536C158.107 42.0813 158.112 42.111 158.112 42.1409C158.112 42.2006 158.088 42.2578 158.046 42.3C158.004 42.3422 157.946 42.3659 157.887 42.3659Z",
    fill: "white"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M157.69 81.9265H57.9495C57.9196 81.927 57.8899 81.9215 57.8622 81.9104C57.8345 81.8993 57.8092 81.8828 57.7879 81.8619C57.7666 81.8409 57.7497 81.816 57.7382 81.7884C57.7266 81.7609 57.7207 81.7313 57.7207 81.7014C57.7207 81.6408 57.7448 81.5826 57.7877 81.5397C57.8306 81.4968 57.8888 81.4727 57.9495 81.4727H157.69C157.72 81.4727 157.749 81.4786 157.777 81.4901C157.805 81.5017 157.83 81.5186 157.85 81.5399C157.871 81.5612 157.888 81.5864 157.899 81.6142C157.91 81.6419 157.916 81.6716 157.915 81.7014C157.915 81.731 157.909 81.7602 157.898 81.7875C157.887 81.8149 157.87 81.8397 157.849 81.8606C157.828 81.8815 157.803 81.898 157.776 81.9094C157.749 81.9207 157.72 81.9265 157.69 81.9265Z",
    fill: "#2F80ED"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.691 81.9265H57.9504C57.9206 81.927 57.8909 81.9215 57.8632 81.9104C57.8354 81.8993 57.8102 81.8828 57.7889 81.8619C57.7676 81.8409 57.7507 81.816 57.7392 81.7884C57.7276 81.7609 57.7217 81.7313 57.7217 81.7014C57.7217 81.6408 57.7458 81.5826 57.7887 81.5397C57.8316 81.4968 57.8898 81.4727 57.9504 81.4727H157.691C157.721 81.4727 157.75 81.4786 157.778 81.4901C157.806 81.5017 157.83 81.5186 157.851 81.5399C157.872 81.5612 157.889 81.5864 157.9 81.6142C157.911 81.6419 157.917 81.6716 157.916 81.7014C157.916 81.731 157.91 81.7602 157.899 81.7875C157.888 81.8149 157.871 81.8397 157.85 81.8606C157.829 81.8815 157.804 81.898 157.777 81.9094C157.75 81.9207 157.721 81.9265 157.691 81.9265Z",
    fill: "white"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M157.69 114.265H57.9495C57.8888 114.265 57.8306 114.241 57.7877 114.198C57.7448 114.155 57.7207 114.097 57.7207 114.037C57.7207 114.007 57.7266 113.977 57.7382 113.95C57.7497 113.922 57.7666 113.897 57.7879 113.876C57.8092 113.855 57.8345 113.839 57.8622 113.828C57.8899 113.817 57.9196 113.811 57.9495 113.812H157.69C157.72 113.812 157.749 113.817 157.776 113.829C157.803 113.84 157.828 113.857 157.849 113.877C157.87 113.898 157.887 113.923 157.898 113.95C157.909 113.978 157.915 114.007 157.915 114.037C157.916 114.066 157.91 114.096 157.899 114.124C157.888 114.152 157.871 114.177 157.85 114.198C157.83 114.219 157.805 114.236 157.777 114.248C157.749 114.259 157.72 114.265 157.69 114.265Z",
    fill: "#2F80ED"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.691 114.265H57.9504C57.8898 114.265 57.8316 114.241 57.7887 114.198C57.7458 114.155 57.7217 114.097 57.7217 114.037C57.7217 114.007 57.7276 113.977 57.7392 113.95C57.7507 113.922 57.7676 113.897 57.7889 113.876C57.8102 113.855 57.8354 113.839 57.8632 113.828C57.8909 113.817 57.9206 113.811 57.9504 113.812H157.691C157.721 113.812 157.75 113.817 157.777 113.829C157.804 113.84 157.829 113.857 157.85 113.877C157.871 113.898 157.888 113.923 157.899 113.95C157.91 113.978 157.916 114.007 157.916 114.037C157.917 114.066 157.911 114.096 157.9 114.124C157.889 114.152 157.872 114.177 157.851 114.198C157.83 114.219 157.806 114.236 157.778 114.248C157.75 114.259 157.721 114.265 157.691 114.265Z",
    fill: "white"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1494 119.736V153.393",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M83.957 119.736V153.393",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7646 119.736V153.393",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5723 119.736V153.393",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3794 119.736V153.393",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M103.188 119.736V153.393",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M107.995 119.736V153.393",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M112.802 119.736V153.393",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M117.609 119.736V153.393",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M122.417 119.736V153.393",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M127.225 119.736V153.393",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M132.032 119.736V153.393",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3892 122.861H131.792",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3892 127.429H131.792",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3892 131.997H131.792",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3892 136.564H131.792",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3892 141.132H131.792",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3892 145.7H131.792",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3892 150.268H131.792",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M90.399 131.543L83.3667 153.223H98.0955L91.0595 131.543C91.037 131.473 90.993 131.412 90.9336 131.368C90.8743 131.325 90.8027 131.302 90.7293 131.302C90.6558 131.302 90.5843 131.325 90.5249 131.368C90.4656 131.412 90.4215 131.473 90.399 131.543Z",
    fill: "#2F80ED",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M103.807 124.363L94.4463 153.223H113.839L104.467 124.363C104.445 124.293 104.401 124.232 104.341 124.189C104.282 124.145 104.21 124.122 104.137 124.122C104.064 124.122 103.992 124.145 103.933 124.189C103.873 124.232 103.829 124.293 103.807 124.363Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M116.145 136.502L110.718 153.224H122.229L116.791 136.502C116.765 136.437 116.721 136.382 116.663 136.342C116.606 136.303 116.538 136.282 116.468 136.282C116.398 136.282 116.33 136.303 116.273 136.342C116.215 136.382 116.171 136.437 116.145 136.502Z",
    fill: "#2F80ED",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M123.579 142.243L120.019 153.223H127.8L124.24 142.243C124.217 142.173 124.173 142.112 124.114 142.069C124.055 142.025 123.983 142.002 123.91 142.002C123.836 142.002 123.765 142.025 123.705 142.069C123.646 142.112 123.602 142.173 123.579 142.243Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5182 109.1C76.4085 109.1 74.3462 108.474 72.5921 107.302C70.838 106.13 69.4708 104.464 68.6635 102.515C67.8562 100.566 67.645 98.4214 68.0565 96.3523C68.4681 94.2831 69.484 92.3825 70.9757 90.8908C72.4675 89.399 74.3681 88.3831 76.4372 87.9716C78.5063 87.56 80.651 87.7712 82.6001 88.5786C84.5491 89.3859 86.215 90.753 87.3871 92.5072C88.5592 94.2613 89.1848 96.3235 89.1848 98.4332C89.1818 101.261 88.0571 103.973 86.0573 105.972C84.0576 107.972 81.3462 109.097 78.5182 109.1ZM78.5182 90.8991C77.0282 90.8998 75.5719 91.3423 74.3334 92.1706C73.0949 92.9989 72.1298 94.1758 71.5602 95.5526C70.9905 96.9293 70.8418 98.4441 71.1329 99.9053C71.4241 101.367 72.1419 102.709 73.1957 103.762C74.2495 104.815 75.592 105.532 77.0534 105.823C78.5147 106.113 80.0294 105.964 81.4059 105.393C82.7824 104.823 83.9588 103.857 84.7865 102.619C85.6142 101.38 86.056 99.9231 86.056 98.4332C86.054 96.435 85.2591 94.5192 83.8458 93.1066C82.4325 91.694 80.5164 90.9 78.5182 90.8991Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M78.518 109.1C77.0785 109.104 75.6531 108.815 74.3291 108.25C73.0051 107.684 71.8104 106.855 70.8179 105.812L73.0796 103.647C73.7803 104.383 74.6242 104.969 75.5593 105.368C76.4945 105.767 77.5013 105.971 78.518 105.967C79.5074 105.967 80.4871 105.772 81.4012 105.394C82.3153 105.015 83.1459 104.46 83.8455 103.761C84.5451 103.061 85.1 102.23 85.4787 101.316C85.8573 100.402 86.0522 99.4226 86.0522 98.4332C86.0522 97.4438 85.8573 96.4641 85.4787 95.55C85.1 94.6359 84.5451 93.8054 83.8455 93.1057C83.1459 92.4061 82.3153 91.8512 81.4012 91.4726C80.4871 91.0939 79.5074 90.8991 78.518 90.8991V87.7666C79.9188 87.7666 81.3058 88.0425 82.6 88.5785C83.8941 89.1146 85.07 89.9003 86.0604 90.8908C87.0509 91.8813 87.8366 93.0571 88.3727 94.3513C88.9087 95.6454 89.1846 97.0324 89.1846 98.4332C89.1846 99.8339 88.9087 101.221 88.3727 102.515C87.8366 103.809 87.0509 104.985 86.0604 105.976C85.07 106.966 83.8941 107.752 82.6 108.288C81.3058 108.824 79.9188 109.1 78.518 109.1Z",
    fill: "#2F80ED",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M104.825 109.1C102.715 109.101 100.652 108.476 98.8975 107.304C97.1429 106.132 95.7752 104.467 94.9673 102.518C94.1594 100.569 93.9477 98.4239 94.3588 96.3545C94.77 94.2852 95.7856 92.3842 97.2772 90.8921C98.7688 89.4 100.669 88.3837 102.739 87.9718C104.808 87.56 106.953 87.771 108.902 88.5782C110.851 89.3854 112.517 90.7526 113.69 92.5068C114.862 94.261 115.487 96.3234 115.487 98.4332C115.485 101.261 114.36 103.971 112.361 105.971C110.362 107.971 107.652 109.096 104.825 109.1ZM104.825 90.8991C103.335 90.9005 101.879 91.3436 100.641 92.1724C99.4028 93.0011 98.4383 94.1783 97.8692 95.5551C97.3001 96.9319 97.152 98.4466 97.4435 99.9075C97.735 101.369 98.4532 102.71 99.5071 103.763C100.561 104.816 101.904 105.533 103.365 105.823C104.826 106.113 106.341 105.964 107.717 105.393C109.093 104.823 110.269 103.857 111.097 102.618C111.924 101.379 112.366 99.923 112.366 98.4332C112.363 96.4346 111.567 94.5189 110.154 93.1064C108.74 91.6939 106.823 90.9 104.825 90.8991Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M108.975 108.259L107.758 105.377C109.358 104.699 110.675 103.488 111.485 101.951C112.295 100.414 112.549 98.6434 112.204 96.9401C111.859 95.2369 110.936 93.7051 109.591 92.6043C108.246 91.5034 106.563 90.901 104.825 90.8991V87.7666C107.286 87.7669 109.671 88.6182 111.576 90.1763C113.482 91.7344 114.789 93.9034 115.278 96.3156C115.766 98.7278 115.406 101.235 114.257 103.411C113.109 105.588 111.243 107.301 108.975 108.259Z",
    fill: "#2F80ED",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M131.128 109.1C129.018 109.1 126.956 108.474 125.201 107.302C123.447 106.13 122.08 104.464 121.273 102.515C120.466 100.566 120.254 98.4214 120.666 96.3523C121.077 94.2831 122.093 92.3825 123.585 90.8908C125.077 89.399 126.977 88.3831 129.047 87.9716C131.116 87.56 133.26 87.7712 135.209 88.5786C137.159 89.3859 138.824 90.753 139.996 92.5072C141.169 94.2613 141.794 96.3235 141.794 98.4332C141.791 101.261 140.666 103.973 138.667 105.972C136.667 107.972 133.956 109.097 131.128 109.1ZM131.128 90.8991C129.637 90.8991 128.181 91.3409 126.942 92.1688C125.703 92.9967 124.737 94.1733 124.167 95.55C123.597 96.9267 123.447 98.4416 123.738 99.903C124.029 101.365 124.746 102.707 125.8 103.761C126.854 104.814 128.196 105.532 129.658 105.823C131.119 106.113 132.634 105.964 134.011 105.394C135.387 104.824 136.564 103.858 137.392 102.619C138.22 101.38 138.662 99.9233 138.662 98.4332C138.66 96.4356 137.865 94.5204 136.453 93.1079C135.04 91.6954 133.125 90.901 131.128 90.8991Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M138.514 96.9315C138.164 95.2314 137.24 93.7037 135.896 92.6051C134.552 91.5065 132.871 90.9041 131.135 90.8991V87.7666C133.594 87.7729 135.975 88.6255 137.878 90.181C139.782 91.7366 141.092 93.9002 141.588 96.308L138.514 96.9315Z",
    fill: "#2F80ED",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7715 75.958H132.865",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7715 75.9579V74.8916",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7886 75.9579V74.8916",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M102.81 75.9579V74.8916",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M112.827 75.9579V74.8916",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M122.844 75.9579V74.8916",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M132.865 75.9579V74.8916",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3865 61.7197H84.1733V70.2611H91.3865V61.7197Z",
    fill: "#F26531",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M101.404 51.7539H94.1904V71.685H101.404V51.7539Z",
    fill: "#F26531",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M111.425 37.8037H104.211V60.015H111.425V37.8037Z",
    fill: "#F26531",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M121.442 58.5908H114.229V62.8634H121.442V58.5908Z",
    fill: "#F26531",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M131.459 56.0264H124.246V67.132H131.459V56.0264Z",
    fill: "#F26531",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3865 70.2646H84.1733V75.9614H91.3865V70.2646Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M101.404 71.6885H94.1904V75.961H101.404V71.6885Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M111.425 60.0117H104.211V75.9581H111.425V60.0117Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M121.442 62.8594H114.229V75.9574H121.442V62.8594Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M131.459 67.1318H124.246V75.9573H131.459V67.1318Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M146.218 33.7698C146.132 33.7704 146.046 33.7495 145.97 33.7089C145.893 33.6683 145.828 33.6094 145.779 33.5373L130.261 10.9054L114.517 27.693L98.442 17.2146L82.8904 20.823L67.0952 33.6517C66.9856 33.7408 66.8452 33.7826 66.7047 33.7681C66.5642 33.7536 66.4353 33.6838 66.3463 33.5742C66.2572 33.4646 66.2153 33.3242 66.2299 33.1837C66.2444 33.0432 66.3141 32.9143 66.4237 32.8253L82.4107 19.8416L98.6449 16.0745L114.355 26.3168L130.394 9.21191L146.657 32.9359C146.713 33.0156 146.745 33.1087 146.751 33.2054C146.757 33.3021 146.736 33.3985 146.692 33.4844C146.647 33.5702 146.579 33.6422 146.497 33.6925C146.414 33.7428 146.319 33.7695 146.222 33.7698H146.218Z",
    fill: "#093269"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0953 33.2381C68.0953 33.4986 68.018 33.7533 67.8733 33.9699C67.7286 34.1865 67.5229 34.3553 67.2822 34.455C67.0415 34.5547 66.7767 34.5808 66.5211 34.53C66.2656 34.4791 66.0309 34.3537 65.8467 34.1695C65.6625 33.9853 65.5371 33.7506 65.4862 33.4951C65.4354 33.2395 65.4615 32.9747 65.5612 32.734C65.6609 32.4933 65.8297 32.2876 66.0463 32.1429C66.2629 31.9982 66.5176 31.9209 66.7781 31.9209C67.1275 31.9209 67.4625 32.0597 67.7095 32.3067C67.9565 32.5537 68.0953 32.8887 68.0953 33.2381Z",
    fill: "#2F80ED"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6507 21.649C83.3781 21.649 83.9679 21.0593 83.9679 20.3318C83.9679 19.6044 83.3781 19.0146 82.6507 19.0146C81.9232 19.0146 81.3335 19.6044 81.3335 20.3318C81.3335 21.0593 81.9232 21.649 82.6507 21.649Z",
    fill: "#2F80ED"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5418 17.9596C99.2692 17.9596 99.859 17.3698 99.859 16.6424C99.859 15.9149 99.2692 15.3252 98.5418 15.3252C97.8143 15.3252 97.2246 15.9149 97.2246 16.6424C97.2246 17.3698 97.8143 17.9596 98.5418 17.9596Z",
    fill: "#2F80ED"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M114.433 28.3199C115.16 28.3199 115.75 27.7302 115.75 27.0027C115.75 26.2753 115.16 25.6855 114.433 25.6855C113.705 25.6855 113.116 26.2753 113.116 27.0027C113.116 27.7302 113.705 28.3199 114.433 28.3199Z",
    fill: "#2F80ED"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M131.641 10.0603C131.641 10.3209 131.563 10.5755 131.419 10.7921C131.274 11.0087 131.068 11.1776 130.828 11.2773C130.587 11.377 130.322 11.403 130.067 11.3522C129.811 11.3014 129.576 11.1759 129.392 10.9917C129.208 10.8075 129.082 10.5728 129.032 10.3173C128.981 10.0618 129.007 9.79697 129.107 9.55628C129.206 9.3156 129.375 9.10988 129.592 8.96515C129.808 8.82042 130.063 8.74316 130.324 8.74316C130.673 8.74316 131.008 8.88194 131.255 9.12896C131.502 9.37598 131.641 9.71101 131.641 10.0603Z",
    fill: "#2F80ED"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M147.532 33.2381C147.532 33.4986 147.455 33.7533 147.31 33.9699C147.166 34.1865 146.96 34.3553 146.719 34.455C146.479 34.5547 146.214 34.5808 145.958 34.53C145.703 34.4791 145.468 34.3537 145.284 34.1695C145.1 33.9853 144.974 33.7506 144.923 33.4951C144.872 33.2395 144.899 32.9747 144.998 32.734C145.098 32.4933 145.267 32.2876 145.483 32.1429C145.7 31.9982 145.955 31.9209 146.215 31.9209C146.564 31.9209 146.899 32.0597 147.147 32.3067C147.394 32.5537 147.532 32.8887 147.532 33.2381Z",
    fill: "#2F80ED"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M174.616 158.78C188.68 158.78 200.081 157.249 200.081 155.36C200.081 153.471 188.68 151.939 174.616 151.939C160.552 151.939 149.15 153.471 149.15 155.36C149.15 157.249 160.552 158.78 174.616 158.78Z",
    fill: "#2F80ED"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M174.616 158.78C188.68 158.78 200.081 157.249 200.081 155.36C200.081 153.471 188.68 151.939 174.616 151.939C160.552 151.939 149.15 153.471 149.15 155.36C149.15 157.249 160.552 158.78 174.616 158.78Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0981 158.78C48.0762 158.78 58.5971 157.249 58.5971 155.36C58.5971 153.471 48.0762 151.939 35.0981 151.939C22.12 151.939 11.5991 153.471 11.5991 155.36C11.5991 157.249 22.12 158.78 35.0981 158.78Z",
    fill: "#2F80ED"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M35.0981 158.78C48.0762 158.78 58.5971 157.249 58.5971 155.36C58.5971 153.471 48.0762 151.939 35.0981 151.939C22.12 151.939 11.5991 153.471 11.5991 155.36C11.5991 157.249 22.12 158.78 35.0981 158.78Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M167.43 34.8694C167.43 34.8694 177.104 33.9323 177.657 35.5446C178.211 37.157 178.026 40.8392 178.026 40.8392C178.514 40.9659 178.989 41.135 179.447 41.3447C179.576 41.4701 181.008 42.4073 179.672 43.9458C179.323 44.336 178.9 44.6532 178.429 44.8793C177.84 45.14 177.279 45.4615 176.757 45.8386L174.816 48.0413L175.185 50.8786C175.185 50.8786 176.052 51.5058 177.111 53.6937C177.111 53.6937 179.613 55.1695 181.081 56.0071C182.289 56.6416 183.545 57.1795 184.837 57.6157C184.837 57.6157 185.509 57.8334 185.461 58.3168C185.413 58.8001 182.118 69.7545 182.118 69.7545L180.384 75.2888C180.351 75.969 180.262 76.6452 180.118 77.3107C179.871 78.5025 178.941 79.2847 177.978 79.0412L178.074 83.0997C178.074 83.0997 173.551 85.3614 166.091 84.9777C166.091 84.9777 162.578 84.6383 159.981 82.716L159.933 73.2337L147.964 70.9167C147.964 70.9167 146.447 70.5957 147.226 69.2305C148.004 67.8654 150.62 64.4784 150.62 64.4784L159.029 54.1918C159.029 54.1918 159.608 53.5092 159.822 53.2915C160.036 53.0739 160.56 52.9226 162.637 52.7492C164.714 52.5758 167.042 52.1736 167.042 52.1736C167.042 52.1736 168.304 51.0889 168.485 51.0889C168.666 51.0889 168.703 49.4654 168.703 49.4654C168.065 49.005 167.534 48.4116 167.147 47.7262C166.761 47.0408 166.527 46.2798 166.463 45.4955C166.282 42.8611 167.437 36.6884 167.437 36.6884L167.43 34.8694Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M160.128 82.6787C160.128 82.6787 159.11 97.806 159.11 105.045C159.11 112.284 159.564 118.147 159.789 123.231C160.014 128.315 159.11 131.817 159.899 135.543C160.689 139.27 162.501 150.117 162.501 150.117L164.629 151.401C164.629 151.401 164.998 142.771 165.773 139.723C166.548 136.676 166.792 123.795 167.249 119.84C167.707 115.885 169.171 101.879 169.171 101.879C169.171 101.879 174.82 116.564 176.182 122.327C177.543 128.09 182.17 141.077 183.192 144.239C184.214 147.401 185.789 152.087 185.789 152.087C186.268 152.227 186.771 152.265 187.265 152.198C187.479 152.181 187.684 152.109 187.862 151.991C188.041 151.872 188.185 151.709 188.283 151.519C188.283 151.519 186.782 142.059 186.121 137.462C185.306 131.776 183.978 123.231 183.17 120.069C182.362 116.907 181.137 111.933 181.137 109.561C181.137 107.189 178.089 83.365 178.089 83.365C178.089 83.365 167.47 87.988 160.128 82.6787Z",
    fill: "#093269"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M169.164 101.88L164.633 96.5967",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M163.475 96.9834L167.205 100.455",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M171.448 97.3708C172.403 94.9541 174.178 92.9505 176.462 91.7109",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M176.717 84.6416C176.717 84.6416 176.204 86.5676 176.846 87.7261C177.488 88.8846 178.134 88.8846 178.134 88.8846C178.134 88.8846 179.289 95.1827 179.289 98.7838C179.289 102.385 178.517 102.769 179.289 106.753C180.06 110.738 180.576 112.026 180.576 114.339C180.576 116.652 181.602 118.198 182.502 119.611C183.402 121.025 183.661 125.146 183.661 126.81C183.661 128.474 184.174 130.282 184.69 131.953C184.69 131.953 184.812 135.702 185.461 136.58C186.111 137.458 186.232 140.439 186.232 140.439",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M168.235 101.355C168.235 101.355 168.489 104.307 167.589 109.454C166.689 114.601 166.047 116.01 165.917 121.925C165.788 127.839 166.305 128.869 166.047 131.953C165.788 135.038 164.246 139.912 164.246 142.125C164.246 144.339 164.482 151.416 164.482 151.416",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M165.405 85.4131L165.663 86.4425L167.334 86.8262L167.076 85.5422",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M167.341 86.8267C167.341 86.8267 170.426 86.6975 171.968 86.1847L171.599 85.1553",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M172.99 84.8965L173.359 86.1841C173.359 86.1841 175.827 86.0439 176.196 85.675",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M165.663 86.4428C164.81 86.416 163.975 86.1952 163.22 85.7971L162.062 85.1551L162.43 84.2549",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M162.501 150.117C162.501 150.117 156.966 153.729 156.173 155.423C155.38 157.116 158.545 156.441 160.803 155.537C163.061 154.633 164.493 151.401 164.493 151.401L162.501 150.117Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M185.966 152.135C186.245 153.683 186.795 155.169 187.59 156.526C188.807 158.419 191.106 160.042 191.106 157.065C191.106 154.087 188.269 151.53 188.269 151.53C188.269 151.53 186.859 152.294 185.966 152.135Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M167.397 36.9131C167.397 36.9131 166.198 44.3513 166.603 46.1961C167.529 50.3247 170.78 50.1476 172.813 49.3581C174.713 48.6201 176.61 46.0116 176.853 45.6685C176.87 45.6443 176.895 45.6262 176.923 45.6168C177.226 45.532 179.104 44.9342 179.93 43.4842C180.834 41.9014 179.141 41.2262 179.141 41.2262",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M175.093 47.5847L176.886 45.6144C176.886 45.6144 179.008 44.9614 179.934 43.4671C180.476 42.5926 180.177 41.8289 179.849 41.6223C179.399 41.3787 178.934 41.1631 178.458 40.9766L177.857 42.3012L177.344 42.3897C177.344 42.3897 177.558 41.0246 176.938 40.2166C176.318 39.4085 176.178 37.0693 176.178 37.0693C176.178 37.0693 175.311 41.733 175.204 43.6848C175.176 44.771 174.837 45.8263 174.226 46.725C174.226 46.725 174.337 47.9167 174.551 49.1085C174.577 49.2487 174.602 49.459 174.628 49.7209L174.923 49.2487L175.086 49.6988C174.901 48.924 174.816 48.1012 175.093 47.5847Z",
    fill: "#2F80ED"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M167.397 36.9131C167.397 36.9131 166.198 44.3513 166.603 46.1961C167.529 50.3247 170.78 50.1476 172.813 49.3581C174.713 48.6201 176.61 46.0116 176.853 45.6685C176.87 45.6443 176.895 45.6262 176.923 45.6168C177.226 45.532 179.104 44.9342 179.93 43.4842C180.834 41.9014 179.141 41.2262 179.141 41.2262",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M171.987 40.6957C171.916 40.9908 171.987 41.2565 172.123 41.2897C172.26 41.3229 172.444 41.1163 172.514 40.8248C172.584 40.5333 172.514 40.2677 172.378 40.2308C172.241 40.1939 172.057 40.4042 171.987 40.6957Z",
    fill: "#093269"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M168.817 39.9245C168.747 40.2197 168.817 40.4853 168.954 40.5185C169.09 40.5517 169.275 40.3451 169.345 40.0536C169.415 39.7622 169.345 39.4928 169.208 39.4596C169.072 39.4264 168.884 39.6293 168.817 39.9245Z",
    fill: "#093269"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M173.953 39.4042C173.779 39.0974 173.53 38.8391 173.231 38.6529C172.931 38.4666 172.59 38.3583 172.237 38.3379",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M169.81 38.3933C169.519 38.2664 169.197 38.2309 168.886 38.2915C168.575 38.3522 168.29 38.5061 168.068 38.7328",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M170.024 39.7363C170.031 40.2306 169.994 40.7245 169.913 41.2122C169.792 41.8283 169.312 41.9501 169.434 42.426C169.555 42.902 170.172 42.95 170.172 42.95",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M170.813 44.8723C171.075 44.9555 171.351 44.9811 171.623 44.9473C171.895 44.9136 172.156 44.8213 172.389 44.6768",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M176.657 31.7186C176.657 31.7186 174.174 29.5713 171.802 29.5713C169.429 29.5713 167.507 30.9291 166.039 31.0471C164.57 31.1652 163.556 29.8037 162.652 31.6116C161.748 33.4195 165.138 36.4708 167.397 36.9209C169.655 37.3711 172.817 36.6959 173.72 36.5815C174.586 36.5221 175.456 36.5221 176.322 36.5815C176.322 36.5815 175.643 38.7288 176.322 39.4077C177.001 40.0866 177.111 40.5367 177.111 40.9869C177.15 41.4837 177.225 41.9769 177.336 42.4627L178.015 42.6915L178.355 41.4481C179.271 40.4714 179.897 39.259 180.162 37.9466C180.498 35.9137 178.805 33.8881 178.805 33.8881L176.657 31.7186Z",
    fill: "#093269"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M167.146 35.995C167.146 35.995 171.009 36.7329 174.034 35.4747C177.06 34.2166 174.451 31.7188 174.451 31.7188",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M175.089 31.5088C175.403 31.5088 178.012 33.4901 177.488 34.9512C176.964 36.4122 175.923 36.5192 175.923 36.5192",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M174.662 76.3254L171.4 74.606C170.562 74.5596 169.728 74.4511 168.906 74.2813C168.146 74.0637 160.346 73.3184 160.346 73.3184L160.228 75.1632C160.228 75.1632 169.124 76.3586 170.965 76.5763C172.806 76.7939 174.437 77.661 174.761 78.2034C175.086 78.7457 175.739 79.2881 175.414 80.7861C175.09 82.2841 172.92 84.4757 172.92 84.4757C172.817 84.3207 178.137 83.937 178.086 83.3688C177.971 82.2398 177.37 78.9413 177.37 78.9413L174.662 76.3254Z",
    fill: "#2F80ED"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M174.662 76.3254L171.4 74.606C170.562 74.5596 169.728 74.4511 168.906 74.2813C168.146 74.0637 160.346 73.3184 160.346 73.3184L160.228 75.1632C160.228 75.1632 169.124 76.3586 170.965 76.5763C172.806 76.7939 174.437 77.661 174.761 78.2034C175.086 78.7457 175.739 79.2881 175.414 80.7861C175.09 82.2841 172.92 84.4757 172.92 84.4757C172.835 84.3096 178.148 83.9333 178.086 83.3688C177.912 81.9299 177.37 78.9413 177.37 78.9413L174.662 76.3254Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M185.42 58.276C185.133 56.9256 182.985 57.1064 181.69 56.3574C180.395 55.6085 177.263 53.8744 177.263 53.8744L175.746 51.5942C175.473 50.9794 175.252 50.3425 175.086 49.6904L174.924 49.2402L174.628 49.7125C174.817 51.7344 174.997 56.9109 174.997 56.9109L175.647 60.1651C175.647 60.1651 178.145 70.9018 178.794 73.2889C179.443 75.6761 179.443 77.2995 179.012 78.0596C178.58 78.8196 178.724 79.1665 178.724 79.1665C178.724 79.1665 180.417 77.8567 180.314 76.5579C180.178 75.0304 185.623 59.191 185.42 58.276Z",
    fill: "#2F80ED"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M185.42 58.276C185.273 56.9035 182.985 57.1064 181.69 56.3574C180.395 55.6085 177.263 53.8744 177.263 53.8744L175.746 51.5942C175.473 50.9794 175.252 50.3425 175.086 49.6904L174.924 49.2402L174.628 49.7125C174.817 51.7344 174.997 56.9109 174.997 56.9109L175.647 60.1651C175.647 60.1651 178.145 70.9018 178.794 73.2889C179.443 75.6761 179.443 77.2995 179.012 78.0596C178.58 78.8196 178.724 79.1665 178.724 79.1665C178.724 79.1665 180.465 77.853 180.314 76.5579C180.141 75.1669 185.553 59.4161 185.42 58.276Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M175.942 56.922C175.942 56.922 175.263 50.8231 174.924 49.2403C174.584 47.6574 174.813 46.7572 173.344 46.7572C171.876 46.7572 170.068 46.5284 170.393 47.3217C170.717 48.1149 172.975 47.4324 173.344 47.7718C173.713 48.1112 173.455 48.9008 173.455 48.9008C173.455 48.9008 170.503 49.1296 170.503 49.9191C170.503 50.7087 170.618 52.8708 171.182 53.0811C171.747 53.2914 171.972 52.0665 171.972 52.0665C171.972 52.0665 172.086 54.6492 172.651 55.5679C173.01 56.1353 173.427 56.6644 173.894 57.147L175.942 56.922Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M173.908 58.6152C173.908 58.6152 173.569 72.6356 174.133 74.8826C174.698 77.1296 177.749 80.1919 179.328 78.7235C180.907 77.255 180.122 74.093 180.122 72.6246C180.122 71.1561 176.506 60.3124 176.506 59.5192C176.452 58.8604 176.299 58.2136 176.052 57.6006",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M174.134 60.3127L176.392 60.084",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M159.693 67.3235L160.128 54.849C160.128 54.849 159.586 54.5243 159.368 55.716C159.151 56.9078 159.044 59.2986 159.044 59.2986C159.044 59.2986 156.439 57.6715 157.092 58.6456C157.745 59.6196 158.826 61.7928 158.826 61.7928L154.797 65.8034L156.642 66.5634L159.693 67.3235Z",
    fill: "#2F80ED"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M159.693 67.3235L160.128 54.849C160.128 54.849 159.586 54.5243 159.368 55.716C159.151 56.9078 159.044 59.2986 159.044 59.2986C159.044 59.2986 156.439 57.6715 157.092 58.6456C157.745 59.6196 158.826 61.7928 158.826 61.7928L154.797 65.8034L156.642 66.5634L159.693 67.3235Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M165.095 57.6344C165.095 57.6344 164.888 58.3724 165.755 58.3724C166.622 58.3724 168.146 57.7562 168.146 57.7562L168.035 56.5312C168.035 56.5312 165.951 57.5459 165.095 57.6344Z",
    fill: "#2F80ED"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M165.095 57.6344C165.095 57.6344 164.888 58.3724 165.755 58.3724C166.622 58.3724 168.146 57.7562 168.146 57.7562L168.035 56.5312C168.035 56.5312 165.951 57.5459 165.095 57.6344Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M168.817 49.3848C168.817 49.3848 167.688 56.026 168.367 57.5019C169.046 58.9777 170.061 58.6309 170.85 57.9557C171.64 57.2805 172.658 55.5833 172.658 55.5833",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M159.9 73.415L160.129 82.6796C160.129 82.6796 162.711 85.1627 167.696 85.1627C172.681 85.1627 178.09 83.3548 178.09 83.3548V80.0784",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M175.152 50.709C175.152 50.709 177.185 52.7419 177.185 54.6642C177.185 56.5865 176.846 57.0366 176.846 57.0366",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M176.957 53.5352C176.957 53.5352 180.008 55.3394 181.701 56.3577C183.395 57.376 185.432 57.3723 185.432 58.2763C185.432 59.1802 180.687 74.5437 180.687 74.5437",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M178.879 58.6152L177.75 63.135",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M159.929 61.2683L158.103 57.4385",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M159.929 62.3645L157.191 60.7227",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M168.861 70.9316L168.315 73.6693",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M183.631 58.1689C183.631 58.1689 180.897 58.715 178.344 61.8143",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M181.808 58.0029C181.808 58.0029 181.07 57.8184 178.528 60.0063",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M168.862 58.8994L167.77 67.4666L168.681 67.6511L169.411 64.9171",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M169.592 81.3252C166.308 84.0629 161.751 83.8784 161.751 83.8784",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M155.715 66.4451C155.715 66.4451 153.483 64.401 150.321 67.0022",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M168.6 51.0479C168.6 51.0479 167.696 51.2729 166.678 52.8558C165.659 54.4386 164.419 57.1467 165.323 57.3718C166.227 57.5969 167.906 56.5822 167.906 56.5822",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M172.101 57.0361L173.23 58.0508",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M167.017 52.1777C167.017 52.1777 162.836 52.7422 161.143 52.8566C159.449 52.971 159.778 53.5945 159.224 53.9856C158.331 54.6092 148.089 67.5928 147.418 68.8362C146.746 70.0796 146.853 70.6441 147.982 70.9835C149.111 71.323 160.357 73.3006 160.357 73.3006L170.293 74.3189L171.083 71.8321C171.083 71.8321 173.392 72.1384 173.798 72.1384",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M169.953 70.9167C167.76 70.2806 165.641 69.4149 163.629 68.334",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M162.726 68.1049C162.726 68.1049 159.405 66.8726 157.608 66.6475C155.812 66.4224 153.059 66.3486 153.059 66.3486",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M159.674 66.637L160.014 57.7119",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M170.293 74.3184C171.068 74.7081 171.88 75.0196 172.717 75.2481",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4633 67.1279L23.7953 59.8484L32.226 56.5277C32.226 56.5277 32.6355 54.266 33.0488 54.1664C33.462 54.0668 33.8679 53.137 33.8679 53.137L33.6649 51.2738C33.6649 51.2738 34.436 48.3221 38.3138 50.6207C38.3138 50.6207 37.1405 51.4029 37.3434 51.7276C37.5464 52.0523 37.1184 53.0854 37.6312 53.0854C38.1441 53.0854 39.1808 53.7384 39.7048 54.266C40.0715 54.66 40.3955 55.0916 40.6714 55.5537L45.0362 55.8046C45.4836 55.8083 45.9287 55.8691 46.3608 55.9854C46.4346 53.8528 46.1726 52.2257 45.6561 50.9602C43.7781 46.3925 40.3541 44.7617 39.8634 42.4741C39.3727 40.1866 39.6199 39.9467 39.6199 39.9467C40.1189 39.4394 40.4842 38.8163 40.6832 38.1331C40.8821 37.4499 40.9085 36.728 40.76 36.0321C40.273 33.5859 38.395 31.8702 31.6246 31.5456C24.8542 31.2209 25.8356 35.8661 25.8356 35.8661L25.9168 36.1907C25.9168 36.1907 21.5926 37.6666 22.4117 43.1235C23.2308 48.5804 25.5921 50.9528 25.5109 52.6647C25.4298 54.3767 22.8987 55.0298 19.3087 58.937C15.7188 62.8443 14.9882 68.7218 16.4567 72.5553C17.1946 74.4407 18.6372 76.0124 20.4488 77.1857L22.4633 67.1279Z",
    fill: "#093269"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1153 67.8477V69.4932L24.9902 79.1489C26.943 79.6656 28.9909 79.7086 30.9637 79.2743C32.0772 78.9841 33.1416 78.5302 34.122 77.9276L28.1153 67.8477Z",
    fill: "#093269"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1001 51.669L37.469 53.3293C37.469 53.3293 38.5759 52.2224 40.738 55.5836C40.738 55.5836 45.2319 55.4766 46.4568 56.0891C46.4568 56.0891 46.7114 56.1629 47.5416 57.0447C48.3717 57.9265 51.4931 60.7343 51.4931 60.7343C51.4931 60.7343 55.5 64.4534 55.8985 64.7412C56.297 65.029 57.7912 66.4568 58.9092 66.9549L61.9051 60.1329L63.2408 56.7569L63.9787 53.9787H64.2148L64.2665 51.7391L64.0857 49.0678C64.1151 48.932 64.1771 48.8054 64.2665 48.6989C64.5758 48.2701 64.8138 47.7942 64.9712 47.2895C64.9712 47.0386 64.7166 45.5553 64.7166 45.5553C64.7166 45.5553 64.5911 45.1864 64.8642 45.1421C65.1372 45.0978 66.1445 45.4483 66.2699 46.1531L66.6389 46.0276C66.9444 45.2976 67.3253 44.6014 67.7753 43.9504C68.373 43.1756 68.9854 42.6885 69.3655 42.9394C69.4698 43.0113 69.5449 43.1182 69.5774 43.2406C69.6099 43.3631 69.5975 43.4931 69.5426 43.6072L68.3545 45.7915C68.3545 45.7915 67.8306 46.4962 68.48 46.7471C68.48 46.7471 69.8857 47.651 69.9779 48.4443C70.0702 49.2375 69.561 49.9201 69.1109 50.5031C68.6608 51.086 67.8675 52.3479 67.8675 52.3479L66.9451 53.1633L66.5761 54.569L67.0115 55.1114L66.3621 57.9265L65.8936 60.037L65.6574 61.3172L64.1816 66.372L62.7058 70.7773C62.7058 70.7773 61.9457 73.301 60.1046 73.2309C58.2635 73.1608 56.2453 72.1646 55.5923 71.8399C54.9392 71.5153 49.5561 68.7038 49.5561 68.7038L48.4492 68.1799C48.5969 68.6838 48.6605 69.2086 48.6374 69.7332C48.6189 70.7072 47.5711 72.8546 47.2649 73.3416L47.0841 77.1493C47.0126 77.8098 47.025 78.4768 47.121 79.1343C47.2833 80.1268 48.1135 85.7423 48.2943 86.4433C48.2943 86.4433 46.5011 88.0667 41.1586 88.8379C35.8161 89.609 33.3145 88.3582 33.3145 88.3582L30.9348 86.9599L33.868 81.1635C33.868 81.1635 34.6059 79.4405 34.5321 78.9867C34.4583 78.5329 33.1965 76.5774 33.1965 76.5774L28.566 68.3348L28.3484 68.4086L27.6289 70.8142L25.0277 78.9719L21.6038 89.1552C21.6038 89.1552 20.6666 91.7379 20.2792 92.5016L19.1982 95.7964C19.2582 96.385 19.4037 96.9617 19.6299 97.5084L16.9106 95.7485L17.394 93.1657L17.9954 89.3138L18.7333 85.1261L19.3827 81.6616L20.4194 77.0423L20.7884 75.7657L21.5263 72.1573L22.825 65.6119L23.9319 60.0074L31.6801 56.9266L32.1634 56.5577C32.2709 55.8444 32.5328 55.1632 32.9308 54.5616C33.2071 54.1658 33.536 53.8096 33.9086 53.5027C33.9086 53.5027 33.8717 53.0194 33.8458 52.5619C33.82 52.1044 33.7019 51.2631 33.7019 51.2631C33.7019 51.2631 36.0965 52.2925 37.1001 51.669Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7212 36.8398C26.7212 36.8398 28.1564 33.6631 31.0269 33.6631C33.8974 33.6631 39.8414 39.3008 39.8414 39.3008",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9497 37.3419C27.9497 37.3419 29.6912 35.4971 31.8459 36.2129C34.0006 36.9286 34.3069 39.4929 34.3069 39.4929",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5145 37.6592C26.5145 37.6592 23.9539 39.0944 23.7473 41.762C23.5407 44.4296 27.3336 47.6026 27.8464 51.1926C28.3593 54.7825 25.6954 55.5979 21.3897 58.5717C17.0839 61.5455 17.8034 68.2052 18.7258 69.6405",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2383 70.4629C19.2383 70.4629 19.8508 71.7948 20.7731 72.2044",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8245 44.6289C26.7033 44.8893 26.6489 45.1758 26.6663 45.4625C26.6837 45.7492 26.7723 46.027 26.9241 46.2708C27.437 47.1932 31.3516 51.8051 31.0269 53.9599C30.7023 56.1146 28.6693 57.4428 28.6693 57.4428",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7689 37.6592C28.7689 37.6592 26.4112 38.6849 26.5145 41.0425C26.6178 43.4002 27.1307 44.0163 27.1307 44.0163",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8413 45.459C40.5739 47.1174 41.579 48.6414 42.8151 49.9677C44.6599 51.8124 44.8628 54.48 44.8628 54.48",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9922 51.292C41.9922 51.292 42.9146 53.4467 42.9146 54.7786",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8896 51.8638L33.9933 54.4723C33.9933 54.4723 33.6834 55.2619 33.1004 56.5274C32.5174 57.7929 32.6134 60.217 32.6134 60.217L34.3991 63.7701C34.3991 63.7701 30.9641 59.8296 30.7686 59.3426C30.573 58.8555 26.9794 59.7337 26.3005 60.0251C25.6216 60.3166 24.7435 60.8996 24.939 61.774C25.1346 62.6484 26.009 63.8106 25.6179 64.0062C25.2268 64.2017 24.1605 63.7147 24.1605 64.2977C24.1605 64.8806 25.4261 67.1165 24.8431 67.8913C24.2602 68.6661 20.5669 81.2034 20.5669 81.2034C20.5669 81.2034 22.8987 79.2589 22.3157 80.0374C21.7328 80.8159 18.9176 87.1288 18.9176 87.1288L17.8477 90.8184L20.375 77.7056L22.5113 66.6369L23.7953 59.848C25.035 59.4348 32.226 56.5274 32.226 56.5274C32.226 56.5274 32.7942 54.1366 33.8678 53.1367L33.6649 51.2734C33.6649 51.2734 35.6241 51.9597 36.8896 51.8638Z",
    fill: "#2F80ED"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.8896 51.8638L33.9933 54.4723C33.9933 54.4723 33.6834 55.2619 33.1004 56.5274C32.5174 57.7929 32.6134 60.217 32.6134 60.217L34.3991 63.7701C34.3991 63.7701 30.9641 59.8296 30.7686 59.3426C30.573 58.8555 26.9794 59.7337 26.3005 60.0251C25.6216 60.3166 24.7435 60.8996 24.939 61.774C25.1346 62.6484 26.009 63.8106 25.6179 64.0062C25.2268 64.2017 24.1605 63.7147 24.1605 64.2977C24.1605 64.8806 25.4261 67.1165 24.8431 67.8913C24.2602 68.6661 20.5669 81.2034 20.5669 81.2034C20.5669 81.2034 22.8987 79.2589 22.3157 80.0374C21.7328 80.8159 18.9176 87.1288 18.9176 87.1288L17.8477 90.8184L20.375 77.7056L22.5113 66.6369L23.7953 59.848C25.035 59.4348 32.226 56.5274 32.226 56.5274C32.226 56.5274 32.3809 54.3137 33.8715 53.5388L33.6649 51.2734C33.6649 51.2734 35.6241 51.9597 36.8896 51.8638Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6709 64.9774C47.6709 64.9774 49.4198 62.0663 49.6153 62.7452C49.8109 63.4241 49.1283 65.7522 49.1283 65.7522C49.1283 65.7522 50.9731 65.0733 50.7812 65.6563C50.5894 66.2393 50.1983 66.5307 50.2942 66.8222C50.3901 67.1137 56.7067 70.4159 57.4852 70.8033C58.2637 71.1907 60.1085 68.9585 60.9829 69.6374C61.8574 70.3162 60.9829 72.6444 59.2341 72.6481C57.4852 72.6518 52.4342 70.4343 52.4342 70.4343L48.4568 68.1209",
    fill: "#2F80ED"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M47.6709 64.9774C47.6709 64.9774 49.4198 62.0663 49.6153 62.7452C49.8109 63.4241 49.1283 65.7522 49.1283 65.7522C49.1283 65.7522 50.9731 65.0733 50.7812 65.6563C50.5894 66.2393 50.1983 66.5307 50.2942 66.8222C50.3901 67.1137 56.7067 70.4159 57.4852 70.8033C58.2637 71.1907 60.1085 68.9585 60.9829 69.6374C61.8574 70.3162 60.9829 72.6444 59.2341 72.6481C57.4852 72.6518 52.4342 70.4343 52.4342 70.4343L48.4715 68.1283",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1812 76.7318C37.1812 76.7318 48.5377 70.7104 46.6929 72.9426C44.8481 75.1748 38.7345 77.7058 37.1812 76.7318Z",
    fill: "#2F80ED"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.1812 76.7318C37.1812 76.7318 48.5377 70.7104 46.6929 72.9426C44.8481 75.1748 38.7345 77.7058 37.1812 76.7318Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M33.665 51.292C33.665 51.292 33.7462 52.8416 33.9934 54.4724C34.2406 56.1032 34.1558 56.1032 35.7054 58.0587C37.255 60.0142 38.8858 61.6487 39.1293 61.324",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2104 60.7525C39.2104 60.7525 39.3727 57.8967 38.8045 56.0224C38.2363 54.1481 37.4172 53.4914 37.4172 53.0708C37.3896 52.6325 37.3354 52.1963 37.2549 51.7646",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6647 53.6572C33.013 54.244 32.5571 55.0168 32.3586 55.871C32.1151 57.1734 31.8716 58.723 31.8716 58.723L34.3989 63.7814C34.619 62.9006 34.9474 62.0504 35.3767 61.2504C35.5893 60.8556 35.8647 60.4979 36.1921 60.1915",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7825 59.3652C39.961 59.3205 40.1465 59.3119 40.3283 59.3397C40.5102 59.3676 40.6846 59.4315 40.8414 59.5275C41.4945 59.8559 42.8006 61.5679 42.8006 61.5679C42.8006 61.5679 41.904 57.3249 40.3544 55.1259C38.8048 52.9269 37.7422 53.0855 37.7422 53.0855",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6243 56.8379L23.795 59.8486C23.795 59.8486 20.943 75.426 19.8804 79.5842C18.8178 83.7423 17.0283 95.49 17.0283 95.49L19.1461 95.8958L19.8841 93.778",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2905 92.5606C20.2905 92.5606 20.7776 91.8227 22.0837 87.7642C23.3898 83.7056 26.8801 73.7438 27.4668 71.7772C28.0534 69.8107 28.5257 68.5156 28.5257 68.5156",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1382 66.1211C27.1382 66.1211 33.7425 77.9278 34.3144 78.4369C34.8863 78.9461 34.0709 80.3112 33.9049 81.0455",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M33.174 82.528L31.0562 86.9334C31.0562 86.9334 32.4434 89.0549 38.3136 89.0549C41.807 89.0656 45.2503 88.2247 48.3455 86.605C48.3455 86.605 46.9583 79.2664 47.0394 77.9603C47.1206 76.6542 47.2866 73.2303 47.2866 73.2303C47.2866 73.2303 48.7625 71.0165 48.5891 69.3156C48.4157 67.6147 47.6925 65.6445 47.6925 65.3198C47.6925 64.9951 47.5302 61.4863 47.5302 61.4863",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3032 75.2777L44.1475 71.6914",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 74.1534L44.5566 72.3086",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8685 67.0322L57.6768 69.9507",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3924 68.3086L57.2671 69.4376",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0789 78.665C25.0789 78.665 23.1308 80.9194 21.7988 81.8418",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9539 79.2773C23.9539 79.2773 20.5706 81.9412 19.7515 82.5574",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5557 60.3135C25.5756 61.7556 26.5 63.2629 27.3229 64.8258",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6436 65.541L28.3593 66.7696",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6924 65.3197L48.5889 60.752",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0215 65.6449L49.4051 63.6895",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M28.525 68.5004L24.6104 66.3789",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0479 61.7305C39.0479 61.7305 40.5237 64.6821 41.007 66.7889",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M63.27 56.5909C63.6604 56.5621 64.0525 56.6126 64.4229 56.7394C64.7932 56.8663 65.134 57.0667 65.4247 57.3288",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4453 93.4639L19.4563 93.8402",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0031 95.6377C17.0158 97.0405 16.9419 98.4428 16.7817 99.8364C16.5382 101.552 16.6194 105.467 16.9441 106.688C17.2688 107.909 17.4348 108.164 17.7595 107.426C18.0841 106.688 19.0656 102.371 19.0656 102.371C19.0656 102.371 19.2279 105.223 19.9621 104.98C20.6964 104.736 20.2905 103.349 20.2905 102.124C20.2905 100.899 20.3717 100.493 20.2905 99.5155C20.2094 98.5377 19.1209 96.121 19.1209 96.121",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0031 95.6377C17.0158 97.0405 16.9419 98.4428 16.7817 99.8364C16.5382 101.552 16.6194 105.467 16.9441 106.688C17.2688 107.909 17.4348 108.164 17.7595 107.426C18.0841 106.688 19.0656 102.371 19.0656 102.371C19.0656 102.371 19.2279 105.223 19.9621 104.98C20.6964 104.736 20.2905 103.349 20.2905 102.124C20.2905 100.899 20.3717 100.493 20.2905 99.5155C20.2094 98.5377 19.1209 96.121 19.1209 96.121",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2218 53.9153C64.1847 53.1939 64.1847 52.471 64.2218 51.7495C64.2883 51.0707 64.0189 50.056 64.0853 49.1668C64.1517 48.2776 65.0336 47.9493 64.897 46.7981C64.7605 45.647 64.4912 45.5105 64.6941 45.2411C64.897 44.9718 66.1699 45.3739 66.2511 46.1192C66.3234 46.8862 66.3234 47.6583 66.2511 48.4252C66.1847 48.6282 66.657 49.9011 66.3876 50.4545C66.2333 50.7543 66.1192 51.0731 66.0482 51.4027",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5244 46.0605C66.5244 46.0605 68.0814 42.9465 68.9632 42.8764C69.845 42.8063 69.572 43.6143 69.299 44.0275C69.0259 44.4407 68.1478 45.9239 68.0814 46.5364C68.015 47.1489 67.1996 49.1745 67.1996 49.1745",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0928 46.5361C68.0928 46.5361 70.4652 47.9566 69.9375 49.1188C69.4099 50.2811 69.1221 50.7459 68.7163 50.5947C68.3564 50.4108 68.0347 50.1604 67.7681 49.8568",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9629 50.5986C68.9629 50.5986 68.3504 51.6133 67.8782 52.2257C67.6066 52.5795 67.2846 52.8915 66.9226 53.1518L66.6348 54.1517",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5161 55.5312C40.5161 55.5312 46.1427 55.45 46.877 56.3466C47.6112 57.2432 56.5031 65.4008 57.5768 66.135C58.6504 66.8693 58.8829 67.0316 58.8829 67.0316C58.8829 67.0316 63.2845 57.0697 63.2845 56.5901C63.2845 56.1104 64.0225 53.9004 64.0225 53.9004C64.0225 53.9004 65.4097 54.0627 65.7381 54.0627C66.0665 54.0627 66.9594 55.1253 66.9594 55.1253C66.9594 55.1253 65.7381 60.0989 65.7381 60.6597C65.7381 61.2205 63.4543 68.9797 62.3917 71.3595C61.3291 73.7393 59.8643 73.3962 57.4993 72.6619C55.1342 71.9277 48.6922 68.2603 48.6922 68.2603",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0559 86.9333C31.0559 86.9333 27.7906 95.102 26.9088 100.662C26.027 106.222 26.4033 119.225 26.1488 120.616C25.8942 122.006 22.3596 128.57 22.3596 131.729C22.3596 134.887 20.4668 151.176 20.4668 151.176L21.7286 151.933C21.7286 151.933 26.1561 138.281 27.7906 134.758C29.4251 131.234 31.7053 122.888 32.3362 121.246C32.9671 119.605 37.3909 106.47 37.6418 104.828C37.8927 103.186 39.4091 99.1458 39.4091 99.1458C39.4091 99.1458 42.6929 119.225 43.3238 123.394C43.9547 127.563 48.3748 150.165 48.3748 150.165C48.6651 150.236 48.9617 150.278 49.2603 150.291C49.6293 150.291 49.7658 149.66 49.7658 149.66C49.7658 149.66 51.5331 133.621 51.0276 129.327C50.5222 125.032 49.0094 119.734 49.0094 118.214C49.0094 116.693 51.2822 103.566 51.2822 99.0278C51.2822 94.4896 48.3305 86.6123 48.3305 86.6123C48.3305 86.6123 37.8558 91.8958 31.0559 86.9333Z",
    fill: "#093269"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9617 119.048C48.9617 119.048 47.8364 123.866 46.2979 126.427",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6559 123.97C48.6559 123.97 47.7335 127.453 45.8887 129.095",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8247 122.432C26.8247 122.432 27.5405 126.634 28.3596 128.376",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6177 124.893C26.6177 124.893 27.2338 127.866 28.3592 129.608",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7383 99.1646L43.8374 95.7812",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M41.686 97.7289L46.5046 95.5742",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M31.126 91.9883C31.126 91.9883 34.3064 94.036 36.1512 95.7812",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6002 151.166C20.6002 151.166 15.8037 155.225 15.8037 157.239C15.8037 159.254 17.6965 159.132 19.7184 157.239C21.7403 155.346 21.8436 151.446 21.8436 151.446L20.6002 151.166Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M48.375 150.166C48.375 150.166 50.0169 154.206 51.7879 155.977C53.5589 157.748 54.5661 158.375 54.5661 156.479C54.5661 154.582 53.4297 152.438 49.7697 149.66C49.766 149.66 50.7769 150.417 48.375 150.166Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4332 38.3379C31.1048 38.2162 30.7949 38.0686 30.4739 37.9321C30.1529 37.7955 29.5663 37.7217 29.3449 38.729C29.0165 40.2048 31.3004 41.4224 30.5661 42.6437C30.1094 43.3866 29.4229 43.9604 28.6107 44.2781C28.4785 44.3236 28.3407 44.3509 28.2011 44.3593C27.5481 44.4405 26.4892 44.3593 26.8138 45.4994C27.1385 46.6395 28.2011 47.6209 28.8542 47.6209H29.5072C29.5072 47.6209 30.2452 49.8347 33.0123 51.0448C35.7795 52.255 37.6612 52.1886 38.3143 50.639C38.9673 49.0894 39.4581 47.7832 39.4581 45.7429C39.4581 43.7026 38.7201 40.2786 38.7201 40.2786C38.7201 40.2786 38.0671 41.1789 35.5397 40.0351C33.8683 39.2788 32.3039 38.6663 31.4332 38.3379Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5419 40.0353C35.5419 40.0353 31.642 39.8176 31.0591 39.9135C30.4761 40.0094 31.155 41.7583 30.9631 43.5072C30.7713 45.256 30.8635 48.0749 31.642 48.9493C32.5607 49.8509 33.5341 50.695 34.5568 51.4767C34.5568 51.4767 31.5645 50.9933 30.4761 49.7278C29.3877 48.4623 29.2143 47.7834 29.2143 47.7834C29.2143 47.7834 26.6869 46.3075 26.4914 45.1601C26.2958 44.0126 27.9672 44.6214 28.7678 44.0532C29.218 43.7433 31.0812 43.1603 30.6126 41.607C30.1441 40.0537 29.3877 39.7622 29.3582 38.7218C29.336 37.9838 29.9854 37.7698 30.3839 37.7034C30.5635 37.6732 30.7481 37.7003 30.9115 37.7809L35.5419 40.0353Z",
    fill: "#2F80ED"
  }))), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4332 38.3379C31.1048 38.2162 30.7949 38.0686 30.4739 37.9321C30.1529 37.7955 29.5663 37.7217 29.3449 38.729C29.0165 40.2048 31.3004 41.4224 30.5661 42.6437C30.1094 43.3866 29.4229 43.9604 28.6107 44.2781C28.4785 44.3236 28.3407 44.3509 28.2011 44.3593C27.5481 44.4405 26.4892 44.3593 26.8138 45.4994C27.1385 46.6395 28.2011 47.6209 28.8542 47.6209H29.5072C29.5072 47.6209 30.2452 49.8347 33.0123 51.0448C35.7795 52.255 37.6612 52.1886 38.3143 50.639C38.9673 49.0894 39.4581 47.7832 39.4581 45.7429C39.4581 43.7026 38.7201 40.2786 38.7201 40.2786C38.7201 40.2786 38.0671 41.1789 35.5397 40.0351C33.8683 39.2788 32.3039 38.6663 31.4332 38.3379Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3144 43.1715C34.3661 43.4814 34.2812 43.7544 34.1226 43.7803C33.9639 43.8061 33.8016 43.5736 33.7536 43.2637C33.7057 42.9538 33.7905 42.6771 33.9455 42.6512C34.1004 42.6254 34.2628 42.8763 34.3144 43.1715Z",
    fill: "#093269"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6903 42.6074C37.7382 42.9173 37.6534 43.1903 37.4984 43.2162C37.3435 43.242 37.1774 43.0095 37.1295 42.6996C37.0815 42.3897 37.1627 42.1167 37.3176 42.0908C37.4726 42.065 37.6386 42.2974 37.6903 42.6074Z",
    fill: "#093269"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3589 41.6656C32.5653 41.3587 32.8454 41.1085 33.1734 40.9377C33.5015 40.7669 33.8671 40.681 34.2369 40.6879",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7646 40.9316C37.0781 40.822 37.4173 40.8103 37.7376 40.8979C38.0578 40.9856 38.3438 41.1684 38.5578 41.4223",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4398 42.3193C36.3947 42.8349 36.3947 43.3534 36.4398 43.869C36.521 44.522 37.008 44.6844 36.8457 45.1751C36.6833 45.6658 36.0303 45.6621 36.0303 45.6621",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2143 47.6213C34.9349 47.6873 34.6445 47.6922 34.363 47.6355C34.0815 47.5788 33.8156 47.462 33.5835 47.293",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharts);
export default __webpack_public_path__ + "static/media/Charts.7dad1e042be03f512941a869472c28bd.svg";
export { ForwardRef as ReactComponent };